import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { MarketingLayout } from '@/components/layout/marketing-layout';

const HomePage = lazy(() => import('@/pages/home'));
const ServicesPage = lazy(() => import('@/pages/services'));
const OutcomePlanPage = lazy(() => import('@/pages/outcome-plan'));
const PrivacyPage = lazy(() => import('@/pages/privacy'));
const NotFoundPage = lazy(() => import('@/pages/not-found'));

function SuspenseRoute({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}

export const router = createBrowserRouter([
  {
    element: <MarketingLayout />,
    children: [
      {
        index: true,
        element: (
          <SuspenseRoute>
            <HomePage />
          </SuspenseRoute>
        ),
      },
      {
        path: '/services',
        element: (
          <SuspenseRoute>
            <ServicesPage />
          </SuspenseRoute>
        ),
      },
      {
        path: '/outcome-plan',
        element: (
          <SuspenseRoute>
            <OutcomePlanPage />
          </SuspenseRoute>
        ),
      },
      {
        path: '/privacy',
        element: (
          <SuspenseRoute>
            <PrivacyPage />
          </SuspenseRoute>
        ),
      },
      // Catches anything else and shows the in-layout 404 (header + footer preserved).
      {
        path: '*',
        element: (
          <SuspenseRoute>
            <NotFoundPage />
          </SuspenseRoute>
        ),
      },
    ],
  },
]);
